<template>
  <div class="creator-entry">
    <div v-if="state === 'loading'" class="entry-state"><i class="el-icon-loading" /> Entering the creator page…</div>
    <div v-else class="entry-state">
      <p>{{ message }}</p>
      <el-button type="primary" @click="$router.replace('/login')">Go to sign in</el-button>
    </div>
  </div>
</template>

<script>
import { redeemCreatorEntryTicket } from '@/apis/front'
import multiAccountManager from '@/utils/multiAccountManager'
export default {
  name: 'CreatorEntry',
  data() { return { state: 'loading', message: '' } },
  async created() {
    const ticket = String(this.$route.query.ticket || '')
    try {
      if (!ticket) throw new Error('Missing entry ticket')
      const response = await redeemCreatorEntryTicket({ ticket })
      const result = response.data
      if (!result || Number(result.code) !== 0 || !result.data) throw new Error((result && result.msg) || 'Could not open the creator page')
      const data = result.data
      this.$store.commit('setUserId', data.user_id)
      this.$store.commit('setUserValue', {
        user_name: data.user_nickName,
        user_avatar_address_small: data.user_avatar_address_small,
        user_type: data.user_type,
        account_type: data.account_type,
        coder_todos_enabled: data.coder_todos_enabled,
        account_role: data.account_role
      })
      this.$store.commit('setUserCreatorLevel', { creator_functionality_level: data.creator_functionality_level })
      multiAccountManager.addAccount({
        user_id: data.user_id,
        user_name: data.user_nickName,
        user_email: data.user_email,
        user_avatar_address_small: data.user_avatar_address_small,
        user_type: data.user_type,
        account_type: data.account_type,
        creator_functionality_level: data.creator_functionality_level,
        coder_todos_enabled: data.coder_todos_enabled,
        account_role: data.account_role
      })
      this.$router.replace('/')
    } catch (error) {
      this.state = 'error'
      this.message = error.message || 'Could not open the creator page'
    }
  }
}
</script>

<style scoped>
.creator-entry { min-height: 100vh; display: flex; align-items: center; justify-content: center; color: #4a5a6d; }
.entry-state { text-align: center; font-size: 14px; line-height: 2; }
</style>
